import c from "classnames";
import { PropsWithChildren } from "react";

import classes from "./Label.module.css";

type Props = PropsWithChildren<{
  label?: string;
  placement?: "stacked" | "side";
}>;

export const Label = ({
  children,
  label,
  placement = "stacked",
  ...rest
}: Props) => {
  return (
    <label className={c(classes.label, classes[placement])} {...rest}>
      {label} {children}
    </label>
  );
};
